function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@bydesign-ui/hooks';
import { deepEqual, shallowEqual } from '@bydesign-ui/utils';
import { PriorityQueue } from '../../../models/priority-queue';
import { TriggerTypeMap } from '../types';
import { validate } from '../util';

function getDefaultValidateResult() {
  var needValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    valid: true,
    partial: needValidate,
    msg: ''
  };
}

export var Validator = function (_Emitter) {
  _inherits(Validator, _Emitter);

  var _super = _createSuper(Validator);

  function Validator(context) {
    var _this;

    _classCallCheck(this, Validator);

    _this = _super.call(this);
    _this.result = getDefaultValidateResult();
    _this.rules = [];
    _this.manual = false;
    _this.state = 'reset';
    _this.validateQueue = _this.initValidateQueue();
    _this.context = context;
    return _this;
  }

  _createClass(Validator, [{
    key: "updateRules",
    value: function updateRules(rules) {
      if (!deepEqual(this.rules, rules)) {
        this.rules = rules;

        if (this.state === 'reset') {
          this.result = getDefaultValidateResult(this.rules.length > 0);
        }

        return true;
      }

      return false;
    }
  }, {
    key: "updateValue",
    value: function updateValue(value) {
      var manual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.manual = this.manual || manual;

      if (this.value !== value) {
        this.value = value;

        if (this.manual || this.state !== 'reset') {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "validate",
    value: function validate(state) {
      var level = state ? state : this.manual ? 'change' : 'reset';

      if (TriggerTypeMap[this.state] < TriggerTypeMap[level]) {
        this.state = level;
      }

      return this.validateQueue.execute('validate', null);
    }
  }, {
    key: "getValidateInfo",
    value: function getValidateInfo() {
      return _objectSpread({
        manual: this.manual
      }, this.result);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.result = getDefaultValidateResult(this.rules.length > 0);
      this.manual = false;
      this.state = 'reset';
      this.emit('change', this.result);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.reset();
      this.removeAllListeners('change');
    }
  }, {
    key: "initValidateQueue",
    value: function initValidateQueue() {
      var _this2 = this;

      return new PriorityQueue([{
        key: 'validate',
        fn: function fn(validateQueue, payload, level) {
          return validate(_this2.context, _this2.rules, _this2.value, _this2.state).then(function (result) {
            var taskInfo = _this2.validateQueue.getTaskInfo('validate');

            if (taskInfo && level && taskInfo.runLevel > level) {
              return;
            }

            _this2.state = 'reset';

            if (shallowEqual(result, _this2.result)) {
              return;
            }

            _this2.result = result;

            _this2.emit('change', result);
          });
        }
      }]);
    }
  }]);

  return Validator;
}(Emitter);